// MCADEX - Frontend

import logo from './logo.svg';
import './App.css';
import { io } from "socket.io-client";
import { useState, useEffect } from 'react';
import axios from 'axios';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import Organizations from './components/OverviewOrganizations';
import Maintenance from './components/Maintenance';

import loginService from './services/login';
import moment from 'moment';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

var socket = null;

// Lähettää komennen backendille
const sendCommand = (mac, command, value) => {
  if (!socket) return;

  let commandToSend = `${mac.toString()} ${command} ${value}`;
  console.log('sendCommand', mac, command, value)
  socket.emit('command', commandToSend);  
}

// Lähettää backendille muutetun configin. Backend tallentaa sen serverille.
const sendConfigUpdate = (newconfig) => {
  if (!socket) return;

  console.log('sendConfigUpdate', newconfig);
  socket.emit('configupdate', newconfig);
}


function App() {
  //const SERVER = "http://10.20.2.36:6081"; // Testattaessa tyrmän backendiä vasten
  //!!!!!!const SERVER = "http://mcadex.savcor.com:6081"; // Tämä on oikea! Backend pilvessä
  const SERVER = "https://mcadex.savcor.com"; // Tämä on oikea! Backend pilvessä
  
  const [connected, setConnected] = useState("false");

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [user, setUser] = useState(null);

  const [userLevel, setUserLevel] = useState(1); // 1=View, 2=Maintenance, 3=Admin
  const [userOrg, setUserOrg] = useState(0); // 0=all,1=Savcor, 2=HSY

  const [ config, setConfig ] = useState(0);
  const [ measurements, setMeasurements ] = useState(0);

  const [ database, setDatabase ] = useState(0);
  const [ history, setHistory ] = useState(0);

  const [ lastCommandSend, setLastCommandSend ] = useState('');
  const [ lastCommandResponse, setLastCommandResponse ] = useState('');

  // Dark / Light theme
  const [theme, setTheme] = useState(localStorage.getItem('theme') || 'dark');  

  // Aikaikkunavalinnat tietokannasta graafeihin hauille
  //{ setSelectedStartDate(date); setSelectedRange(null); setSelectedRefresh('Off'); } }
  const [ selectedStartDate, setSelectedStartDate ] = useState(null);
  const [ selectedEndDate, setSelectedEndDate ] = useState(null);
  const [ selectedRange, setSelectedRange ] = useState(null);
  const [ selectedRefresh, setSelectedRefresh ] = useState('Off');

  //console.log('theme', theme)

  useEffect(() => {
    localStorage.setItem('theme', theme);
    document.body.className = theme;
  }, [theme]);
  // .. Dark / Light theme

  // Tämä suoritetaan ainoastaan ensimmäisen renderöinnin yhteydessä
  useEffect(() => {
    console.log('useEffect alkaa')
    // Hakee configin rest-rajapinnasta
    axios.get(`${SERVER}/config`)
      // ja vasta configin jälkeen avataan websocket yhteys backendiin
      .then((response) => {
        //console.log('config', response.data);
        setConfig(response.data);

        // WebSocket yhteys  backendiin
        socket = io(SERVER, {allowEI03: true});
        //socket = io('wss://mcadex.savcor.com');
        //console.log('socket', socket)

        // Backendistä tulee mittausdataa
        socket.on('mcdata', (message) => {
          //console.log('mcdata', message)
          setMeasurements(message);
        });

        socket.on('commandresponse', (message) => {
          //let timestamp = new Date().toISOString();
          let pattern = "DD.MM.YYYY HH:mm:ss.SSS"
          let timestamp = moment().format(pattern);
          console.log(timestamp, 'commandresponse', message);

          setLastCommandResponse(timestamp + ' ' + message);
        });

        socket.on('connection-test', (message) => {
          console.log('testing system..', message);
        });
});


    // Haetaan koko database
    axios.get(`${SERVER}/database`)
      .then((response) => {
        console.log('axios database', response.data)
        setDatabase(response.data);
      });

    // Haetaan kannasta viimeisen vuorokauden historia
    axios.get(`${SERVER}/history`)
    .then((response) => {
      //console.log('axios history 2', JSON.parse(response.data))
      setHistory(response.data);
    });

  }, []);

  // Localstorageen tallennetut käyttäjätiedot
  useEffect(() => {
    const loggedUserJSON = window.localStorage.getItem('loggedUser');
    if (loggedUserJSON) {
      const user = JSON.parse(loggedUserJSON);
      setUser(user);
    }
  }, []);

  // Login buttonia painettu. Tarkistetaan onko käyttää ja mitkä sen oikeudet on.
  // LoginService tekee kyselyn backendiin /api/login, joka antaa vastaukset.
  const handleLogin = async (event) => {
    event.preventDefault();
    console.log('logging in with', username, password)

    try {
      const user = await loginService({
        username, password
      })

      window.localStorage.setItem(
        'loggedUser', JSON.stringify(user)
      );
      console.log('login - handlelogin user:', user)

      setUser(user);
      setUserLevel(user.level); // Tämä tieto olisi jo userissa...
      setUserOrg(user.organization); // ... niin kuin tämäkin

      setUsername('');
      setPassword('');
    } catch (exception) {
      //setErrorMessage('wrong credentials');
      console.log('error wrong credentials')
      
    }
  }
//  <div className="logo" style={{padding: '5px', marginTop: '10px', marginLeft: '10px', align:'center'}} >

  // Apufunktiot
  const loginForm = () => (

    <>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        verticalAlign: 'center',
        horizontalAlign: 'center',
        alignContent: 'center',
        justifyContent: 'center',
      }}>

        <div className="loginlogo" style={{padding: '5px', marginTop: '20px', marginLeft: '10px', align:'center'}} >
            <img className="icon" fill="#000000" style={{width:'100%'}} align="center" alt="Savcor" />
        </div>

        <br/>

        <div>
          <form onSubmit={handleLogin}>
          <div>
            
              <input
              type="text"
              value={username}
              name="Username"
              placeholder="Käyttäjätunnus"
              onChange={({ target }) => setUsername(target.value)}
            />
          </div>
          <div>
            
              <input
              type="password"
              value={password}
              name="Password"
              placeholder="Salasana"
              onChange={({ target }) => setPassword(target.value)}
            />
          </div>
          <button className="btn btn-primary" type="submit" style={{marginTop: '10px'}}>login</button>

          </form>      
        </div>
      </div>
    </>
  )

// Hakee kannasta valitun aikaikkunan
const setRange = (selectedStart, selectedEnd) => {
  if (!selectedStart) return;
  if (!selectedEnd) selectedEnd = Date.now();

  let start = new Date(selectedStart).toISOString();
  let end = new Date(selectedEnd).toISOString();
  let interval = '1h';
  //console.log('range', start, end, interval)
  //console.log('range-test', `${SERVER}/history?begin=${start}&end=${end}&interval=${interval}`)


  let range_seconds = (Date.parse(end) - Date.parse(start)) / 1000; // Milliseconds to seconds
  //console.log('range_seconds', range_seconds)
  let range_minutes = range_seconds / 60;
  //console.log('range_minutes', range_minutes)
  let range_hours = range_minutes / 60;
  //console.log('range_hours', range_hours)
  
  if (range_seconds <= 1000) {
    interval = '1s';
  }
  else if (range_minutes <= 1000) {
    interval = '1m';
  }
  else {
    let interval_as_number = Math.ceil(range_hours/1000); 
    interval =`${interval_as_number}h`;
  }
  
  //let range_hours_in_1000 = Math.ceil(range_hours/1000);
  //console.log('range_hours_in_1000', range_hours_in_1000)
  //console.log('range_interval', interval)



    // Haetaan kannasta viimeisen vuorokauden historia
    axios.get(`${SERVER}/history?begin=${start}&end=${end}&interval=${interval}`)
    .then((response) => {
      //console.log('axios history 2', JSON.parse(response.data))
      setHistory(response.data);
    });  
}


/* tämä ylempää ennen </>
  <div>
    <br/>
    <center><em>Savcor 2024</em></center>
  </div>
*/

  // Callback-funktio, joka välitetään lapsille. Jos lapsien täytyy lähettää viestejä, tullaan tänne.
  const event_from_child = (action, sender, data) => {
    console.log('Heippa! dataa lapselta', action, sender, data, socket);
    
    let msg = data;

    // Lähetetään komento backendille
    if (action === "sendcommand") {
      console.log('sendcommand', sender, data)
      
      sendCommand(data['mac'], data['command'], data['value']);




   
      // Infokentässä näytetään lähetetty komento
      let commandToSend = `${data['mac'].toString()} ${data['command']} ${data['value']}`;
      let pattern = "DD.MM.YYYY HH:mm:ss.SSS"
      let timestamp = moment().format(pattern);
      console.log(timestamp, 'commandsend', commandToSend);
      setLastCommandSend(timestamp + ' ' + commandToSend);
    
    }
    else if (action === "add")
      addRowToConfig(sender, data);
    else if (action === "update")
      updateConfig(sender, data);
    else if (action === "delete")
      deleteConfig(sender, data);

    //saveConfig();
  }

  // Lisää käyttöliittymästä saadun rivin configiin 
  const addRowToConfig = (sender, data) => {
    console.log('addRowToConfig', typeof(data), data)
    let databasetable = sender;

    // Hakee taulusta suurimman id:n ja lisää sitä yhdellä uudelle riville
    let suurin = Math.max(...database[databasetable].map(o => o.id))
    data['id'] = suurin + 1;

    database[databasetable].push(data);

    //console.log('updateConfig jälkeen', database)

    // Pidetään koko database muuttujassa
    setDatabase(database);

    // Lähetetään uusi database kaikille käyttäjille
    sendConfigUpdate(database);
  }

  // Päittää koko configin uudella 
  const updateConfig = (sender, data) => {
    console.log('updateConfig', sender, typeof(data), data)
    let databasetable = database;
    //console.log('updateconfig2', sender)
    databasetable[sender] = data;

    // Pidetään koko database muuttujassa
    setDatabase(databasetable);

    // Lähetetään uusi database kaikille käyttäjille
    sendConfigUpdate(database);
  }


  // Poistaa kannasta yhden ririn
  const deleteConfig = (sender, id) => {
    console.log('delete from table', sender, 'row with id', id)

    // Kopioidaan nykyisestä databasesta valitun taulun rivit newDatabaseen
    const newDatabase = [...database[sender]];

    // Haetaan nykyisen databasen taulusta poistettavan rivin indeksi
    const index = database[sender].findIndex((item) => item.id === id);
    console.log('delete index', index)

    // ..ja poistetaan se newDatabasesta
    newDatabase.splice(index, 1);

    // Kopioidaan nykyinen database updatedDatabaseen ja kopioidaan muutettu taulu viimeisenä
    let updatedDatabase = new Object();
    updatedDatabase['organizations'] = [...database['organizations']];
    updatedDatabase['personnel'] = [...database['personnel']];
    updatedDatabase['sites'] = [...database['sites']];
    updatedDatabase['devices'] = [...database['devices']];
    updatedDatabase[sender] = [...newDatabase];

    setDatabase(updatedDatabase);

    // Lähetetään uusi config backendille, joka hoitaa varsinaisen kannasta poiston
    sendConfigUpdate(updatedDatabase);
  }

  // Lähettää configin backendille, joka tallentaa sen tietokantaan
  const saveConfig = () => {
    console.log('Heippa saveConfig', config)

    if (socket != null)
    {
      socket.emit('configupdate', config);
      console.log('configupdate lähetetty')
    }
  
  }




  // Appissa näytettävä pääformi. Sisältää Overview- ja Maintenance -välilehdet
  const mainForm = () => {
    // HSY:lle räätälöity. HSY:n ja Savcorin logot, välilehdet puuttuu

    {/*    
      return (
  <>
    <div className="flex-container" style={{width: '100%'}}>
        <div className="customer-logo" style={{padding: '5px'}} >
              <img className="icon" fill="#000000" style={{width:'50%'}}  alt="HSY" />
        </div>

        <div className="logo" style={{padding: '5px', marginTop: '10px', marginRight: '10px'}} >
          <img className="icon" fill="#000000" style={{width:'50%'}}  alt="Savcor" />
        </div>

    </div>
                
    <div className="logout" style={{marginRight: '10px'}} >
        <button class="btn btn-primary" type="button" onClick={() => { window.localStorage.removeItem('loggedUser'); setUser('') }}>logout</button>
    </div>


        
    <Organizations config={config} measurements={measurements} history={history} userOrg={userOrg} main_callback={event_from_child}></Organizations>
    </>
      )
      */}

    return (

      <>
        {userLevel === 1 ? (
          <div className="flex-container" style={{ width: '100%' }}>
            <div className="customer-logo" style={{ padding: '5px' }} >
              <img className="icon" fill="#000000" style={{ width: '50%' }} alt="HSY" />
            </div>

            <div className="logo" style={{ padding: '5px', marginTop: '10px', marginRight: '10px' }} >
              <img className="icon" fill="#000000" style={{ width: '50%' }} alt="Savcor" />
            </div>

          </div>
        ) : (
          <div className="logo" style={{ padding: '5px' }} >
            <img className="icon" fill="#000000" style={{ width: '100%' }} align="left" alt="Savcor" />
          </div>

        )}



        {/* Vasemman yläkulman Savcor-logo */}
{/*        <div className="logo" style={{ padding: '5px' }} >
          <img className="icon" fill="#000000" style={{ width: '100%' }} align="left" alt="Savcor" />
        </div>
    */}
        {/* Oikean yläkulman tietokantahaun aikarajaus */}
        <div className="d-flex align-items-end flex-column mb-3">
          <div className="range">
            Timerange
            <DatePicker className=""
              selected={selectedStartDate}
              onChange={(date) => { setSelectedStartDate(date); setSelectedRange(null); setSelectedRefresh('Off'); }}

              dateFormat="dd.MM.yyyy HH:mm"
              showTimeSelect
              timeFormat="HH:mm"
            />

            <DatePicker className=""
              selected={selectedEndDate}
              onChange={(date) => { setSelectedEndDate(date); setSelectedRange(null); setSelectedRefresh('Off'); }}
              dateFormat="dd.MM.yyyy HH:mm"
              showTimeSelect
              timeFormat="HH:mm"
            />
            <button class="btn btn-primary" type="button" onClick={() => { console.log('range clicked', selectedStartDate, selectedEndDate); setRange(selectedStartDate, selectedEndDate) }}>Apply</button>
          </div>
        </div>

        {/* User level 2=Maintenance ja 3=Admin komponentit: Overview- ja Maintenance-välilehdet. User level 1=View: Ainoastaan overview näkymä. */}
        {userLevel > 1 ? (
          <>
            <Tabs
              defaultActiveKey="overview"
              id="uncontrolled-tab-example"
              className="mb-3"
              fill
            >

              <Tab eventKey="overview" title="Overview">
                <Organizations config={config} measurements={measurements} history={history} userOrg={userOrg} userLevel={userLevel} main_callback={event_from_child}></Organizations>
              </Tab>

              <Tab eventKey="maintenance" title="Maintenance">
                <Maintenance disabled database={database} main_callback={event_from_child}>Testataan miten toimii</Maintenance>
              </Tab>

            </Tabs>

            <div className="commandsend">Last command send: {lastCommandSend}</div>
            <div className="commandresponse">Last command response: {lastCommandResponse}</div>
          </>
        ) : (     
          <Organizations config={config} measurements={measurements} history={history} userOrg={userOrg} userLevel={userLevel} main_callback={event_from_child}></Organizations>
        )}

        {/* Oikean alakulman logout-nappi */}
        <div className="logout" style={{ marginRight: '10px' }} >
          <button class="btn btn-primary" type="button" onClick={() => { window.localStorage.removeItem('loggedUser'); setUser('') }}>logout</button>
        </div>

      </>
    )
  } // mainForm


  //console.log('Maintenance database', database)

  return (
    <div className="App">
      <header className="MCadEx">

      </header>

      <body>
        {/* Näytetään logoform jos ei olla sisäänkirjautuneena, muuten pääformi. */}
        {!user && loginForm()}
        {user && mainForm()}

        {/* Kaikilla sivuilla näkyvä alareunan teksti */}
        <div>
          <br />
          <center className="company"><em>Savcor 2024</em></center>
        </div>

      </body>
    </div>
  );


  // Admin

  if (userLevel == 3) {
    return (
      <div className="App">
        <header className="MCadEx">

        </header>

        <body>
          <div className="logo" style={{ padding: '5px' }} >
            <img className="icon" fill="#000000" style={{ width: '100%' }} align="left" alt="Savcor" />


          </div>



          <Tabs
            defaultActiveKey="overview"
            id="uncontrolled-tab-example"
            className="mb-3"
            fill
          >

            <Tab eventKey="overview" title="Overview">
              <Organizations config={config} measurements={measurements} history={history} userOrg={userOrg} main_callback={event_from_child}></Organizations>
            </Tab>

            <Tab eventKey="maintenance" title="Maintenance">
              <Maintenance database={database} main_callback={event_from_child}>Testataan miten toimii</Maintenance>
            </Tab>

          </Tabs>

          <div>
            <div className="commandsend">Last command send: {lastCommandSend}</div>
            <div className="commandresponse">Last command response: {lastCommandResponse}</div>
            <br />
            <center><em>Savcor 2024</em></center>
          </div>


        </body>
        <div className="logout" style={{ marginRight: '10px' }} >
            <button class="btn btn-primary" type="button" onClick={() => { window.localStorage.removeItem('loggedUser'); setUser('') }}>logout</button>
          </div>



      </div>


    );
  }
  // Maintenance
  else if (userLevel == 2) {
    return (
      <div className="App">
        <header className="MCadEx">

        </header>

        <body>

          <div className="logo" style={{ padding: '5px' }} >
            <img className="icon" fill="#000000" style={{ width: '100%' }} align="left" alt="Savcor" />
          </div>


          <Tabs
            defaultActiveKey="overview"
            id="uncontrolled-tab-example"
            className="mb-3"
            fill
          >

            <Tab eventKey="overview" title="Overview">
              <Organizations config={config} measurements={measurements} history={history} userOrg={userOrg} main_callback={event_from_child}></Organizations>
            </Tab>

            <Tab eventKey="maintenance" title="Maintenance">
              <Maintenance database={database} main_callback={event_from_child}>Testataan miten toimii</Maintenance>
            </Tab>

          </Tabs>

          <div className="logout" style={{ marginRight: '10px' }} >
            <button class="btn btn-primary" type="button" onClick={() => { window.localStorage.removeItem('loggedUser'); setUser('') }}>logout</button>
          </div>


          <div>
            <br />
            <center><em>Savcor 2024</em></center>
          </div>

        </body>
      </div>
    );
  }
  // View
  else {
    return (
      <div className="App">
        <header className="MCadEx">

        </header>

        <body>
          {!user && loginForm()}
          {user && mainForm()}

          <div>
            <br />
            <center className="company"><em>Savcor 2024</em></center>
          </div>

        </body>
      </div>
    );
  }

}

export default App;
